import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { DialogueData } from '../../../../general/Dialogue';
import { CharacterDialogue } from '../../../../general/Character';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { SortingData } from '../..';
import { t } from 'ttag';
import { AllZookeepers } from '../../../sorting/characters/Zookeepers';

const TuringOutro: React.FC<ISlide<SortingData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: AllZookeepers,
            text: t`From all of us here at the Barefoot family farm, thank you so much for your help. We couldn’t have done it without you! We hope to see you soon.`,
            buttonText: t`Bye!`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default TuringOutro;
